import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { formatParams } from 'pages/plannings/utils/planning'
import { toast } from 'react-toastify'


const ExportButton = () => {
  const { state } = useLocation()
  const params = useMemo(() => formatParams(state), [state])
  const xlsxUrl = `/planning?format=xlsx&${params}`
  const pdfUrl = `/planning?format=pdf&${params}`

  const handleAjaxCall = async url => {
    try {
      const response = await fetch(url, { method: 'GET' })
      if (response.ok) {
        const successMessage = 'Votre demande a bien été prise en compte,' +
                         'vous allez recevoir le fichier par email dans quelques minutes'
        toast.success(successMessage)
      }
      else
        toast.error('Une erreur est survenue')
    } catch (_error) {
      toast.error('Une erreur est survenue')
    }
  }

  return (
    <>
      <button
        type="button"
        className="btn btn-primary float-right mt-1"
        data-toggle="modal"
        data-target="#exportModal"
      >
        <span>Exporter</span>
      </button>
      <div
        className="modal fade export-modal"
        id="exportModal" aria-labelledby="exportModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exportModalLabel">
                <i className="fa-solid fa-file-export pr-1" />
                {' '}
                Exporter le planning
              </h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body pb-0">
              <div className="row">
                <div className='col'>
                  <a
                    onClick={() => handleAjaxCall(xlsxUrl)}  // eslint-disable-line react/jsx-no-bind
                  >
                    <div className='card'>
                      <div className='card-body'>
                        <div className='text-center mb-2'>
                          <h4 className='card-title'>
                            Export Excel
                          </h4>
                          <i className="fa-solid fa-file-invoice fa-4x" />
                          <p className='card-text pt-2'>
                            Exportez le planning opérationnel au format Excel pour une vue d’ensemble.
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                <div className='col'>
                  <a
                    onClick={() => handleAjaxCall(pdfUrl)} // eslint-disable-line react/jsx-no-bind
                  >
                    <div className='card'>
                      <div className='card-body'>
                        <div className='text-center mb-2'>
                          <h4 className='card-title'>
                            Export groupé des PDF
                          </h4>
                          <i className="fa-solid fa-file-pdf fa-4x" />
                          <p className='card-text pt-2'>
                            Configurez un export groupé des PDF que vous avez paramétrés dans les services.
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ExportButton